import Vue from 'vue';

import layoutLogin from '@/layouts/layout-login';
import layoutAdmin from '@/layouts/layout-admin';
import generalFilter from '@/components/shared/general-filter';
import appTable from '@/components/shared/table/app-table';
import headerPage from '@/components/shared/header-page';
import formSidebar from '@/components/shared/form-sidebar';
import modalSidebarButton from '@/components/shared/utils/modal-sidebar-button';

Vue.component('layout-login', layoutLogin);
Vue.component('layout-admin', layoutAdmin);
Vue.component('app-table', appTable);
Vue.component('header-page', headerPage);
Vue.component('general-filter', generalFilter);
Vue.component('form-sidebar', formSidebar);
Vue.component('modal-sidebar-button', modalSidebarButton);



// WEBPACK FOOTER //
// ./src/global-components.js